import { WorkflowStateNode } from '../../../../services/ducks/workflowDuck/workflowDuck';
import { ValidatorFn } from '../../../inputs/ErrorMessageInputText';

export const isLabelUnique = (value: string, nodes: any): boolean => {
  if (!nodes) {
    throw new Error(`Nodes is null or undefined: ${nodes}`);
  }
  value = (value || '').trim();
  return !Object.values(nodes).find((node: any) => node.state === value);
};

export const labelValidator =
  (nodes: Record<string, WorkflowStateNode>): ValidatorFn =>
  (value?: any): string => {
    if (!isLabelUnique(value, nodes)) {
      return 'Labels must be unique.'; //TODO localise this string
    }
    return '';
  };
